<template>
  <div class="messages">
    <template v-if="messages">
      <div v-for="group in messagesByDate" :key="group.date" class="messages__group">
        <div class="messages__date">
          <span>{{ group.date }}</span>
        </div>
        <Message
          v-for="(message, i) in group.messages"
          :key="message.id"
          :message="message"
          :selected="checkSelected(message)"
          :select-mode="selectedMode"
          :quote="i === 0"
          :forward="i === 1"
          :isAdmin="isAdmin"
          @select="$emit('select', message)"
          @select-mode="$emit('select-mode')"
          @reply="$emit('reply', $event)"
          @forward="$emit('forward', $event)"
        />
      </div>
      <div v-if="typing" class="messages__typing">
        <div class="messages__user">
          <img :src="typingInfo.avatar" alt="" />
        </div>
        <div class="messages__typing-content">
          {{ typingInfo.content }}
        </div>
      </div>
    </template>

    <div v-else class="messages__loader">
      <Loader :loading="true" theme="block" />
    </div>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy'
import moment from 'moment'

import { withUi } from '@/components/ui'
import Message from './Message'
import socketDialog from '@/mixins/socketDialog'
import { mapGetters } from 'vuex'

export default {
  mixins: [withUi, socketDialog],
  components: { Message },
  props: {
    activeDialog: Number,
    messages: Array,
    typing: Object,
    isAdmin: Boolean,
    selected: [Array, null],
  },
  data: () => {
    return {
      typing: null,
    }
  },
  computed: {
    selectedMode() {
      return !!this.selected?.length
    },
    typingInfo() {
      const user = this.members.find((item) => item.id === this.typing);
      console.log(user, this.typing);
      return {
        avatar: user.avatar,
        content: `${this.$localized(user.localized_name, user.first_name)} ${this.$t('chat.message.is_typing')}`,
      }
    },
    messagesByDate() {
      const formatMask = 'DD MMM'

      const dates = this.messages.map((x) => moment(x.author.last_action_at).format(formatMask))
      const datesGrouped = Object.keys(groupBy(dates))

      return datesGrouped.map((date) => {
        const messages = this.messages.filter(
          (message) => moment(message.author.last_action_at).format(formatMask) === date,
        )
        return {
          date,
          messages,
        }
      })
    },
    ...mapGetters('chat', ['members']),
  },

  methods: {
    checkSelected(msg) {
      if (Array.isArray(this.selected)) {
        return this.selected.includes(msg.id)
      }
      return null
    },
  },
  watch: {
    channel: {
      immediate: true,
      handler(channel) {
        if(channel) {
          channel.listenForWhisper('typing', ({ user, typing }) => {
            if (typing) {
              this.typing = user
            } else if(this.typing === user) {
              this.typing = null
            }
          })
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.messages {
  position: relative;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 24px 24px 8px;
  // &__loader {

  // }

  &__typing {
    display: flex;
    align-items: center;


    &-content {
      padding: 8px 24px;
      background: #F0F3F7;
      color: #47474780;
      border-radius: 10px 10px 10px 0;

      font-size: 15px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  &__user {
    position: relative;
    z-index: 1;
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    margin-right: 12px;
    border-radius: 5px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__date {
    position: relative;
    margin: 8px 0 16px 0;

    span {
      position: relative;
      padding-right: 12px;
      z-index: 2;
      font-weight: 700;
      font-size: 14px;
      line-height: 150%;
      color: $dark;
    }
  }
}
</style>
